import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Col, Row, Container} from 'react-bootstrap';
import SectionHeading from '../components/section-heading';
import WiderImage from '../components/wider-image';
import RelatedBlogs from '../components/related-blogs';

import { fetchArticleById,fetchRelatedArticlesByTag } from '../redux/actions/actions';

class BlogDetails extends Component {
  async componentDidMount() {
    let { loadArticleById,  match:{params:{articleId}}, loadRelatedArticles}= this.props;
    await loadArticleById(articleId);
    // let { } = this.props;
    loadRelatedArticles(this.props.article[0].tags);
  }
  render() {
    
    return(
      <div className="le-blog-details">
        {
          this.props.article?this.props.article.map((data, index) => (
            <div key={index}>
              <Container>
                <SectionHeading align="heading-left" subText={data.date} heading={data.title} />
              </Container>
              <WiderImage image={data.images.headerImage} alt={data.title}/>
              <Container>
                <div className="blog-content" dangerouslySetInnerHTML={{__html: data.content}}></div>
                <Row className="tag-container">
                  <Col md={12}>
                    <span>Tags:</span>
                    {
                      data.tags.length?data.tags.map((tag, index) => (
                      <a href={`#${tag}`} className="tags">{tag}</a>
                      )):null
                    }
                  </Col>
                </Row>
                <SectionHeading subText="More Post" heading="You might also like" align="heading-center"/>
                <RelatedBlogs articleList={this.props.relatedArticles} loadMore={true}/>
              </Container>
            </div>
          )):'empty'
        }
        
      </div>
    )
  }
};

const maptStateToProps = ({linenedges}) => ({
  article: linenedges.openedArticle,
  relatedArticles: linenedges.relatedArticles
});

const mapDispatchToProps = dispatch => ({
  loadArticleById: async (articleId) => await dispatch(fetchArticleById(articleId)),
  loadRelatedArticles: async (tags) => await dispatch(fetchRelatedArticlesByTag(tags))
}); 

export default connect(maptStateToProps, mapDispatchToProps)(BlogDetails);